var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Graphic_x0020_Style_x0020_12{opacity:0.15;fill:#45413C;}\n\t.st0{opacity:0.15;fill:#45413C;}\n\t.st1{fill:#FFE500;}\n\t.st2{fill:#EBCB00;}\n\t.st3{fill:none;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFAA54;}\n\t.st5{fill:#FF8A14;}\n\t.st6{fill:#FFB0CA;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#FF87AF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#FFCC99;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:#F0F0F0;}\n\t.st11{fill:#BF8256;}\n\t.st12{fill:#915E3A;}\n\t.st13{fill:#DEA47A;}\n\t.st14{fill:#F0D5A8;}\n\t.st15{fill:#DEBB7E;}\n\t.st16{fill:#F7E5C6;}\n\t.st17{fill:#FF8A14;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFF5E3;}\n\t.st19{fill:#FFF48C;}\n\t.st20{fill:#FFFACF;}\n\t.st21{fill:#FFFCE5;}\n\t.st22{fill:#FF87AF;}\n\t.st23{fill:#FFB0CA;}\n\t.st24{fill:#FFE500;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:#9CEB60;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:#FFFACF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:#00F5BC;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st28{fill:#BF8256;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st29{fill:#FFE3CF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st30{fill:#FF6242;}\n\t.st31{fill:#FF866E;}\n\t.st32{fill:none;stroke:#E04122;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st33{fill:#FFFEF2;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st34{fill:#FF6242;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st35{fill:#FFA694;}\n\t.st36{fill:#FFFFFF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st37{fill:#FFFEF2;}\n\t.st38{fill:#FF6196;}\n\t.st39{fill:#B89558;}\n\t.st40{fill:none;stroke:#915E3A;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st41{fill:#DEBB7E;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st42{fill:#6DD627;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st43{fill:#E5F8FF;}\n\t.st44{fill:#E8F4FA;}\n\t.st45{fill:#E8F4FA;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st46{fill:#FFCCDD;}\n\t.st47{fill:#E5F8FF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st48{fill:#00B8F0;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st49{fill:#00B8F0;}\n\t.st50{fill:#4ACFFF;}\n\t.st51{fill:#E04122;}\n\t.st52{fill:#E04122;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st53{fill:#87898C;}\n\t.st54{fill:#BDBEC0;}\n\t.st55{fill:#656769;}\n\t.st56{fill:#525252;}\n\t.st57{fill:#FFF48C;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st58{fill:#6DD627;}\n\t.st59{fill:#EB6D00;}\n\t.st60{fill:#46B000;}\n\t.st61{fill:#80DDFF;}\n\t.st62{fill:#DAEDF7;}\n\t.st63{fill:#BF8DF2;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st64{fill:#9F5AE5;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st65{fill:#C8FFA1;}\n\t.st66{fill:#E4FFD1;}\n\t.st67{fill:#9CEB60;}\n\t.st68{fill:#E5FEFF;}\n\t.st69{fill:#B8ECFF;}\n\t.st70{fill:#E0E0E0;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st71{fill:#E0E0E0;}\n\t.st72{fill:none;stroke:#4F4B45;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st73{fill:none;stroke:#4F4B45;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st74{fill:#E0366F;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st75{fill:none;stroke:#45413C;stroke-miterlimit:10;}\n\t.st76{fill:#FF866E;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st77{fill:#45413C;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st78{fill:#9F5AE5;}\n\t.st79{fill:#803EC2;}\n\t.st80{fill:#803EC2;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st81{fill:#BF8DF2;}\n\t.st82{fill:#FFAA54;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st83{fill:none;stroke:#45413C;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st84{fill:#FFCCDD;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st85{fill:#FF6196;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st86{fill:#FFE5EE;}\n\t.st87{fill:#F7E5C6;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st88{fill:#E5FFF9;}\n\t.st89{fill:none;stroke:#45413C;stroke-width:1.0064;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st90{fill:#4AEFF7;}\n\t.st91{fill:#A6FBFF;}\n\t.st92{fill:#E5FEFF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st93{fill:#46B000;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st94{fill:#FFFFFF;stroke:#45413C;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st95{fill:#FFFFFF;stroke:#45413C;stroke-miterlimit:10;}\n\t.st96{fill:#009FD9;}\n\t.st97{fill:#00DFEB;}\n\t.st98{fill:#C0DCEB;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st99{fill:#00DFEB;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st100{fill:#FFE5EE;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st101{fill:#8CA4B8;}\n\t.st102{fill:#ADC4D9;}\n\t.st103{fill:#656769;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st104{fill:#F0F0F0;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st105{fill:#C0DCEB;}\n\t.st106{fill:#45413C;}\n\t.st107{fill:#FFCABF;}\n\t.st108{fill:#87898C;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st109{fill:#EBCB00;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14472_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14502_",
    className: "st92",
    d: "M32.9,20.8v3.6h3.2c0.9,0,1.6,0.7,1.6,1.6v4.8c0,1.3-0.8,2.5-2,3L32.9,35v4.4l4.6-2 c2.4-1,3.9-3.4,3.9-5.9v-6.7c0-2.2-1.8-4-4-4H32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14501_",
    className: "st1",
    d: "M34.1,41.9h-23l0,0c0.8-0.8,1.2-1.8,1.2-2.9V17.2h20.6v21.8C32.9,40,33.4,41.1,34.1,41.9 L34.1,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14500_",
    className: "st19",
    d: "M22.4,17.2H12.3v21.8c0,1.1-0.4,2.1-1.2,2.9h11.3V17.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_14499_",
    className: "st0",
    cx: 22.6,
    cy: 45.5,
    rx: 14.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14498_",
    className: "st3",
    d: "M34.1,41.9h-23l0,0c0.8-0.8,1.2-1.8,1.2-2.9V17.2h20.6v21.8C32.9,40,33.4,41.1,34.1,41.9 L34.1,41.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14497_",
    className: "st2",
    cx: 16,
    cy: 26.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14496_",
    className: "st2",
    cx: 30.1,
    cy: 23.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14495_",
    className: "st36",
    cx: 33.3,
    cy: 8.5,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14494_",
    className: "st36",
    cx: 11.7,
    cy: 8.3,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14493_",
    className: "Graphic_x0020_Style_x0020_12",
    d: "M12.3,19.6c0.1,0,0.3,0,0.4,0c0.5,0,0.9-0.1,1.3-0.3v2.9 c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.8c0.4,0.1,0.8,0.2,1.3,0.2c0.3,0,0.6,0,0.9-0.1v5.3c0,1.1,0.9,1.9,1.9,1.9 c1.1,0,1.9-0.9,1.9-1.9v-5.2c1.1,0,2.1-0.3,3-0.9c0.7,0.5,1.6,0.9,2.6,0.9c1,0,1.9-0.3,2.6-0.9c0.5,0.5,1.3,0.9,2.1,0.9 c0.1,0,0.3,0,0.4,0v-2.5H12.3V19.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14484_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14492_",
    className: "st3",
    x1: 17.1,
    y1: 1.1,
    x2: 17.1,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14491_",
    className: "st3",
    x1: 18.3,
    y1: 1.6,
    x2: 18.8,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14490_",
    className: "st3",
    x1: 18.9,
    y1: 2.9,
    x2: 19.5,
    y2: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14489_",
    className: "st3",
    x1: 18.3,
    y1: 4.2,
    x2: 18.8,
    y2: 4.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14488_",
    className: "st3",
    x1: 17.1,
    y1: 4.7,
    x2: 17.1,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14487_",
    className: "st3",
    x1: 15.8,
    y1: 4.2,
    x2: 15.3,
    y2: 4.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14486_",
    className: "st3",
    x1: 15.2,
    y1: 2.9,
    x2: 14.6,
    y2: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14485_",
    className: "st3",
    x1: 15.8,
    y1: 1.6,
    x2: 15.3,
    y2: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14481_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14483_",
    className: "st3",
    x1: 26.7,
    y1: 5,
    x2: 26.7,
    y2: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14482_",
    className: "st3",
    x1: 25.8,
    y1: 4.2,
    x2: 27.5,
    y2: 4.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14480_",
    className: "st36",
    d: "M35.5,15.1c0-1.7-1.3-3-3-3c-0.3,0-0.5,0-0.7,0.1c-0.6-1.6-2.2-2.7-4-2.7 c-0.3,0-0.6,0-0.8,0.1C26,8,24.2,7,22.2,7c-2,0-3.7,1-4.7,2.6c0,0,0,0,0,0c-1.8,0-3.3,1.1-4,2.7c-0.2-0.1-0.5-0.1-0.7-0.1 c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3v2.9c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-2.8 c0.4,0.1,0.8,0.2,1.3,0.2c0.3,0,0.6,0,0.9-0.1v5.3c0,1.1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9v-5.2c1.1,0,2.1-0.3,3-0.9 c0.7,0.5,1.6,0.9,2.6,0.9c1,0,1.9-0.3,2.6-0.9c0.5,0.5,1.3,0.9,2.1,0.9C34.2,18.2,35.5,16.8,35.5,15.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14479_",
    className: "st2",
    cx: 28.1,
    cy: 34.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14478_",
    className: "st2",
    cx: 18.4,
    cy: 36.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14477_",
    className: "st2",
    cx: 14.8,
    cy: 30.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14476_",
    className: "st2",
    cx: 25.7,
    cy: 26.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14474_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14475_",
    className: "st36",
    d: "M21.9,31.3c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.7,0.9-2.3,1.3-3.1 c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.1,0.3,0.2C21,29,21.9,30.6,21.9,31.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14473_",
    className: "st92",
    d: "M35.7,43.7c0,1-0.8,1.8-1.8,1.8H11.3c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8H34 C35,41.9,35.7,42.7,35.7,43.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/beer.446a0ade817773a6973e42748d77ac9c.svg";
export { ForwardRef as ReactComponent };